export default __webpack_public_path__ + "static/media/sad.72b06534.svg";